var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgCheckedBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#3D82F1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.339 3.661A12.418 12.418 0 0 0 12.5 0C9.161 0 6.022 1.3 3.661 3.661A12.418 12.418 0 0 0 0 12.5c0 3.339 1.3 6.478 3.661 8.839A12.418 12.418 0 0 0 12.5 25c3.339 0 6.478-1.3 8.839-3.661A12.418 12.418 0 0 0 25 12.5c0-3.339-1.3-6.478-3.661-8.839ZM12.5 23.535c-6.085 0-11.035-4.95-11.035-11.035S6.415 1.465 12.5 1.465 23.535 6.415 23.535 12.5 18.585 23.535 12.5 23.535Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.47 8.488a.732.732 0 0 0-1.035 0l-6.467 6.468-3.405-3.405a.732.732 0 0 0-1.036 1.036l3.923 3.922a.73.73 0 0 0 1.035 0l6.986-6.985a.732.732 0 0 0 0-1.036Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v25H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBox);
export default __webpack_public_path__ + "static/media/CheckedBox.002e617ad03613ffa052a577c0a3ba0f.svg";
export { ForwardRef as ReactComponent };